// Database işlemeleri yapılacak ve dönen datanın state e geçmesi için mutation a gönderilecek
import sendReq from '@/utils/request'

export const fetchTickets = async ({ commit }, data) => {
  commit('ticketLoading', true)
  let res;
  res = await sendReq('get', 'tickets', data)
  commit('setTickets', res.data)
  commit('ticketLoading', false)
}

export const fetchTicket = async ({ commit }, id) => {
  commit('ticketLoading', true)
  let res;
  res = await sendReq('get', `tickets/${id}`)
  commit('setTicket', res.data)
  commit('ticketLoading', false)
}

export const addTicket = async ({ commit }, data) => {
  commit('ticketLoading', true)
  let res;
  res = await sendReq('post', 'tickets', data)
  commit('ticketStatus', res.data.status)
  commit('ticketLoading', false)
}

export const fetchComments = async ({ commit }, data) => {
  commit('ticketLoading', true)
  let res;
  res = await sendReq('get', `tickets/${data.id}/comments`, data.params)
  commit('setTicketComments', res.data)
  commit('ticketLoading', false)
}

export const addComment = async ({ commit }, data) => {
  commit('ticketLoading', true)
  let res;
  res = await sendReq('post', `tickets/${data.ticket_id}/comments`, data)
  commit('ticketStatus', res.data.status)
  commit('ticketLoading', false)
}

export const appointTicket = async ({ commit }, data) => {
  commit('ticketLoading', true)
  let res;
  res = await sendReq('put', `tickets/${data.ticket_id}/assigned-user`, data)
  commit('ticketStatus', res.data.status)
  commit('ticketLoading', false)
}

export const addFile = async ({ commit }, data) => {
  commit('ticketLoading', true)
  let res;
  res = await sendReq('put', `tickets/${data.ticket_id}/comments/${data.comment_id}`, data.file)
  commit('ticketStatus', res.data.status)
  commit('ticketLoading', false)
}

export const fetchCustomerProducts = async ({ commit }, id) => {
  // loading componentte kontrol ediliyor
  let res;
  res = await sendReq('get', `/customers/${id}/products`)
  commit('setCustomerProducts', res.data)
}

export const closeTicket = async ({ commit }, id) => {
  commit('ticketLoading', true)
  const res = await sendReq('put', `/tickets/${id}/close`)
  commit('ticketStatus', res.data.status)
  commit('ticketLoading', false)
}

export const getTicketFileUrl = async (_, path) => {
  const res = await sendReq('get', path, { responseType: 'blob' })
  return URL.createObjectURL(res.data)
}

export const setTicketState = async ({ commit }, data) => {
  commit('ticketLoading', true)
  let res;
  res = await sendReq('put', 'tickets/'+data.ticket_id+'/status', data)
  commit('ticketStatus', res.data.status)
  commit('ticketLoading', false)
}



// WEBPACK FOOTER //
// ./src/store/modules/Ticket/Actions.js